export default (theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        maxWidth: 700,
    },
    action: {
        alignSelf: 'flex-end',
        marginTop: 12,
    },
    // Override DataGrid styles
    sectionList: {
        '& .ag-body-viewport.ag-layout-auto-height .ag-center-cols-container, & .ag-body-viewport.ag-layout-auto-height .ag-center-cols-clipper':
            {
                minHeight: 40,
            },
        '&.ag-theme-balham': {
            '& .ag-header-row:first-child .ag-header-cell ': {
                paddingLeft: 16,
                paddingRight: 16,
                ...theme.typography.subtitle,
            },
            '& .ag-cell': {
                ...theme.typography.body,
            },
        },
    },
    loading: {
        '& $sectionList': {
            minHeight: 164,
        },
    },
});
